import { useRequest } from '../../../../../lib/hooks';
import { request } from '../../../../../lib/utils/request';
import {
	InsertSearchTagDto,
	SearchTagDto,
	UpdateSearchTagDto,
} from '../dto/SearchTagDto';

const BASE_URL = `${process.env.REACT_APP_SEARCH_TAGS_API}/search-tags`;

export async function findSearchTagByCpf(cpf: string): Promise<SearchTagDto | null> {
	try {
		const tag = await request().get<SearchTagDto>(`${BASE_URL}/by-cpf/${cpf}`);
		return tag || null;
	} catch (err: any) {
		if (err?.response?.status === 404) return null;
		throw err;
	}
}

export function useSearchTagsApi() {
	const insert = useCreateTag();
	const update = useUpdateTag();
	const remove = useRemoveTag();

	return {
		insert,
		update,
		remove,
	};
}

function useCreateTag() {
	const [result, loading, error, do_create] = useRequest<SearchTagDto>(
		(dto: InsertSearchTagDto) =>
			new Promise((resolve, reject) => {
				request()
					.post(`${BASE_URL}`, dto)
					.then((res: any) => setTimeout(() => resolve(res), 1500))
					.catch(reject);
			})
	);

	return {
		create: (dto: InsertSearchTagDto) => do_create(dto),
		result,
		error,
		loading,
	};
}

function useUpdateTag() {
	const [result, loading, error, do_update] = useRequest<SearchTagDto>(
		(dto: UpdateSearchTagDto) =>
			new Promise((resolve, reject) => {
				request()
					.put(`${BASE_URL}/${dto.id}`, {
						title: dto.title,
						prefix: dto.prefix,
						cpf: dto.cpf,
					})
					.then((res: any) => setTimeout(() => resolve(res), 1500))
					.catch(reject);
			})
	);

	return {
		do_update: (dto: UpdateSearchTagDto) => do_update(dto),
		result,
		error,
		loading,
	};
}

function useRemoveTag() {
	const [result, loading, error, remove] = useRequest<string>(
		(id: string) =>
			new Promise((resolve, reject) => {
				request()
					.delete(`${BASE_URL}/${id}`)
					.then((res: any) => setTimeout(() => resolve(res), 1500))
					.catch(reject);
			})
	);

	return {
		do_remove: (id: string) => remove(id),
		result,
		loading,
		error,
	};
}
